import { getSkeletonAnimation } from '@/utils/getSkeletonAnimation';
import styled from '@emotion/styled';
import xw from 'xwind';

export const Header = styled.div`
  height: 220px;
  background-color: #f6f7f8;
  border-radius: 0 0 20px 20px;

  @media (min-width: 768px) {
    height: 330px;
    margin: 0 0 30px;
    border-radius: 1.25rem;
  }

  ${getSkeletonAnimation()}
`;

export const Container = styled.div`
  ${xw('sm[container mx-auto sm:px-4]')}
`;

export const FlexGroup = styled.div`
  display: flex;
  gap: 20px;
  margin: 80px 0;

  @media (max-width: 768px) {
    margin: 40px 20px;
    flex-direction: column;
  }
`;

export const SquareGroup = styled.div`
  width: 50%;
  height: 350px;
  border-radius: 1.25rem;
  background-color: #f6f7f8;

  @media (max-width: 1280px) {
    height: 270px;
  }

  @media (max-width: 1020px) {
    height: 200px;
  }

  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 20px;
  }

  ${getSkeletonAnimation()}
`;
